import appInfo from "./appInfo";
import fetchBuildInfo from "./fetchBuildInfo";

const reducers = {
  appInfo,
  fetchBuildInfo,
};

export default reducers;
